import { render } from "./YouTubeImporter.vue?vue&type=template&id=1f8fb922"
import script from "./YouTubeImporter.vue?vue&type=script&lang=js"
export * from "./YouTubeImporter.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__